import axios, { AxiosError, AxiosResponse } from 'axios'
import { isParameterError, isServerError, getParamErrorMessage, getServerErrorMessage } from '../error/index'

axios.defaults.baseURL = process.env.REACT_APP_STO_API

interface ResponseDataType {
  CODE: string
}

export const HttpReq = async <T>(param: {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  url: string
  data?: Record<string, any>
}): Promise<T | null> => {
  let resRaw: AxiosResponse<any, any>
  const httpPromise =
    param.method === 'GET'
      ? axios.get(param.url, { params: param.data, withCredentials: true })
      : param.method === 'POST'
      ? axios.post(param.url, param.data, { withCredentials: true })
      : param.method === 'DELETE'
      ? axios.delete(param.url, { data: param.data, withCredentials: true })
      : axios.put(param.url, param.data, { withCredentials: true })
  try {
    resRaw = await httpPromise
  } catch (error: unknown) {
    const isAxiosError = <ResponseDataType>(error: unknown): error is AxiosError<ResponseDataType> => {
      return axios.isAxiosError(error)
    }
    if (isAxiosError<ResponseDataType>(error)) {
      if (error.response?.status === 400) {
        // console.log(isParameterError(error.response?.data.CODE))
        // console.log(getParamErrorMessage(error.response?.data.CODE))
        if (isParameterError(error.response?.data.CODE)) {
          alert(getParamErrorMessage(error.response?.data.CODE))
        }
      }

      if (error.response?.status === 500) {
        // console.log(isServerError(error.response?.data.CODE))
        // console.log(getServerErrorMessage(error.response?.data.CODE))
        if (isServerError(error.response?.data.CODE)) {
          alert(getServerErrorMessage(error.response?.data.CODE))
        }
      }
    }
    return null
  }
  return resRaw.data
}
